import { render, staticRenderFns } from "./reviewed.vue?vue&type=template&id=b63de656&scoped=true&"
import script from "./reviewed.vue?vue&type=script&lang=js&"
export * from "./reviewed.vue?vue&type=script&lang=js&"
import style0 from "./reviewed.vue?vue&type=style&index=0&id=b63de656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63de656",
  null
  
)

export default component.exports